module.exports = __webpack_public_path__ + "img/safari-pinned-tab.b8b20b3b.svg";